'use client';

import { useEffect } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('[Global Error]', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-cs-surface-page flex items-center justify-center">
      <div className="text-center space-y-4 px-8">
        <div className="w-14 h-14 mx-auto rounded-xl bg-cs-error-bg border border-cs-error-500/30 flex items-center justify-center">
          <AlertTriangle className="w-7 h-7 text-cs-error-400" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-semibold text-cs-text-primary">Something went wrong</h1>
        <p className="text-sm text-cs-text-muted max-w-sm">
          An unexpected error occurred. If this keeps happening, please contact support.
        </p>
        {error.digest && (
          <p className="text-xs font-mono text-cs-text-disabled">Error ID: {error.digest}</p>
        )}
        <button
          onClick={reset}
          className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-md bg-cs-primary-500 text-white text-sm font-medium hover:bg-cs-primary-600 transition-colors"
        >
          <RefreshCw className="w-4 h-4" aria-hidden="true" />
          Try again
        </button>
      </div>
    </div>
  );
}
